import Vue from 'vue'

const actions = {

  /**
   * @param context
   */
  getData (context) {
    Vue.axios.get('role')
      .then(response => {
        for (let index = 0; index < response.data.length; index++) {
          addRoleIdsField(response.data[index])
        }

        context.commit('SET_ROLELIST', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },

  /**
   * @param context
   */
  async getRoles (context) {
    let roleList = await Vue.axios.get('role')
      .then(response => {
        return JSON.parse(JSON.stringify(response.data))
      })
      .catch(error => {
        console.log(error)
      })
    return roleList
  },

  addRole (context, role) {
    context.commit('ADD_ROLE', role)
  },

  addRolesSelectedLeft (context, roles) {
    context.commit('SET_ROLES_SELECTED_LEFT', roles)
  },

  addRolesSelectedRight (context, roles) {
    context.commit('SET_ROLES_SELECTED_RIGHT', roles)
  },

  async assignPrivilegesToRoles (context, data) {
    let response
    await Vue.axios.patch('role/' + data.roleId, { Privileges: data.privilegesIds })
      .then(response => {
        addRoleIdsField(response.data)

        context.commit('UPDATE_ROLE_IN_ROLELIST', response.data)
        response = response.data
      })
      .catch(error => {
        console.log(error)
      })
    return response
  },

  async getRoleData (context, params) {
    let path = 'role/' + params.data.roleId
    let populate = []
    let requestParam

    if (params.options && params.options.populate && !params.options.populate) {
      populate = []
      requestParam = { params: { populate: populate.join(',') } }
    }

    let role = await Vue.axios.get(path, requestParam)
      .then(response => {
        addRoleIdsField(response.data)

        context.commit('UPDATE_ROLE_IN_ROLELIST', response.data)
        return JSON.parse(JSON.stringify(response.data))
      })
      .catch(error => {
        console.log(error)
      })
    return role
  },

  async createRoleData (context, params) {
    let response
    params.data.Privileges = params.data.PrivilegeIds

    delete params.data.id
    await Vue.axios.post('role', params.data)
      .then(response => {
        addRoleIdsField(response.data)

        context.commit('ADD_ROLE_TO_ROLELIST', response.data)
        response = response.data
      })
      .catch(error => {
        console.log(error.response.statusText)
      })

    return response
  },

  async updateRoleData (context, params) {
    let response
    params.data.Privileges = params.data.PrivilegeIds
    delete params.data.Users
    delete params.data.UserIds

    await Vue.axios.patch('role/' + params.data.id, params.data)
      .then(response => {
        addRoleIdsField(response.data)

        context.commit('UPDATE_ROLE_IN_ROLELIST', response.data)
        response = response.data
      })
      .catch(error => {
        console.log(error)
      })

    return response
  }
}

let addRoleIdsField = function (roleData) {
  roleData.PrivilegeIds = roleData.Privileges.map(item => item.id)
  roleData.UserIds = roleData.Users.map(item => item.id)
}

export default actions



//////////////////
// WEBPACK FOOTER
// ./state/role/role.actions.js
// module id = null
// module chunks = 